import { useRef, useState } from "react";
import { Play, Pause, Download, Headphones } from "lucide-react";
import { formatDate, mediaUrl } from "@/lib/api";

const fmt = (s) => (isNaN(s) ? "0:00" : `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, "0")}`);
const SPEEDS = [1, 1.25, 1.5, 2];

export const PodcastPlayer = ({ podcast: p, testId }) => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [time, setTime] = useState(0);
  const [dur, setDur] = useState(0);
  const [speed, setSpeed] = useState(1);

  const toggle = () => { const a = ref.current; if (a.paused) { a.play(); } else { a.pause(); } };
  const cycleSpeed = () => { const s = SPEEDS[(SPEEDS.indexOf(speed) + 1) % SPEEDS.length]; setSpeed(s); ref.current.playbackRate = s; };
  const src = mediaUrl(p.audio_url);

  return (
    <div data-testid={testId} className="news-card p-4 flex flex-col sm:flex-row gap-4 hover:translate-y-0">
      <div className="w-full sm:w-32 h-32 bg-[#111827] shrink-0 overflow-hidden flex items-center justify-center text-red-600">
        {p.cover_url ? <img src={mediaUrl(p.cover_url)} alt="" className="w-full h-full object-cover" /> : <Headphones size={40} />}
      </div>
      <div className="flex-1 min-w-0">
        <div className="meta"><span>{formatDate(p.created_at)}</span><span>/</span><span>{p.host}</span>{p.duration && <><span>/</span><span>{p.duration}</span></>}</div>
        <h3 className="font-heading font-extrabold text-lg mt-1 leading-snug">{p.title}</h3>
        <p className="text-sm text-zinc-600 mt-1 line-clamp-2">{p.description}</p>
        <audio ref={ref} src={src} preload="metadata" onPlay={() => setPlaying(true)} onPause={() => setPlaying(false)} onTimeUpdate={(e) => setTime(e.target.currentTime)} onLoadedMetadata={(e) => setDur(e.target.duration)} onEnded={() => setPlaying(false)} />
        <div className="flex items-center gap-3 mt-3">
          <button data-testid={`${testId}-play`} onClick={toggle} aria-label={playing ? "Pause" : "Lecture"} className="w-11 h-11 rounded-full bg-red-600 text-white flex items-center justify-center hover:bg-red-700 transition-colors shrink-0">
            {playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
          </button>
          <span className="text-xs tabular-nums text-zinc-500 w-10">{fmt(time)}</span>
          <input type="range" className="player-range flex-1" min={0} max={dur || 0} step={0.1} value={time} onChange={(e) => { ref.current.currentTime = Number(e.target.value); }} />
          <span className="text-xs tabular-nums text-zinc-500 w-10">{fmt(dur)}</span>
          <button data-testid={`${testId}-speed`} onClick={cycleSpeed} className="text-xs font-bold border border-zinc-300 px-2 py-1 hover:border-red-600 hover:text-red-600 transition-colors">{speed}×</button>
          <a href={src} download target="_blank" rel="noreferrer" aria-label="Télécharger" className="text-zinc-500 hover:text-red-600 transition-colors"><Download size={16} /></a>
        </div>
      </div>
    </div>
  );
};
